import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react"; // uses lucide-react for clean icons
import DonationPopup from "../../DonationPopup";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDonationPopupOpen, setIsDonationPopupOpen] = useState(false);

  // disable scroll when menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isOpen]);

  const toggleMenu = () => setIsOpen(!isOpen);

  const handleDonateClick = () => {
    setIsDonationPopupOpen(true);
  };

  const handleCloseDonationPopup = () => {
    setIsDonationPopupOpen(false);
  };

  const handleNavigation = (item) => {
    const pageMap = {
      'Home': 'home',
      'About': 'about',
      'Programs': 'programs',
      'Events': 'events',
      'Video': 'video',
      'Gallery': 'gallery',
      'Resource': 'resource',
      'Blog': 'blog',
      'Contact': 'contact'
    };
    
    const page = pageMap[item];
    if (page === 'home') {
      window.location.href = '/';
    } else {
      window.location.href = `/?page=${page}`;
    }
  };

  const navItems = [
    "Home",
    "About",
    "Programs",
    "Events",
    "Video",
    "Gallery",
    "Resource",
    "Blog",
    "Contact",
  ];

  return (
    <div className="relative font-aleo bg-[#FFEBB5] w-full">
      
      {/* Desktop Navbar */}
      <div className="hidden lg:flex justify-between items-center px-8 py-4">
        {/* Logo */}
        <div className="flex items-center">
          <img
            className="w-28 h-28"
            src="/assets/logo-vishwa-sanatan.svg"
            alt="LOGO ICON"
          />
        </div>
        
        {/* Navigation Items */}
        <ul className="flex justify-center items-center gap-14 text-[#67142D] font-semibold">
          {navItems.map((item) => (
            <li
              key={item}
              onClick={() => handleNavigation(item)}
              className="cursor-pointer hover:text-[#B51F3B] transition-colors duration-200"
            >
              {item}
            </li>
          ))}
        </ul>
        
        {/* Donate Button */}
        <div className="flex justify-center items-center gap-14 text-[#67142D] font-semibold">
          <button
            onClick={handleDonateClick}
            className="bg-[#67142D] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#B51F3B] transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:scale-105"
          >
            Donate Now
          </button>
        </div>
      </div>

      {/* Mobile Navbar */}
      
      <div className="lg:hidden flex justify-between items-center p-4">
        <div className="flex items-center">
            <img
              className="w-28 h-28"
              src="/assets/logo-vishwa-sanatan.svg"
              alt="LOGO ICON"
            />
        </div>
        <div className="flex items-center">
          <button onClick={toggleMenu} aria-label="Toggle Menu">
            {isOpen ? <X size={28} color="#67142D" /> : <Menu size={28} color="#67142D" />}
          </button>
        </div>
      </div>

      {/* Fullscreen Mobile Menu */}
      {isOpen && (
        <div className="fixed top-0 left-0 w-full h-full bg-[#FFF8E6] flex flex-col justify-center items-center z-50 overflow-y-auto">
          <button
            className="absolute top-6 right-6"
            onClick={toggleMenu}
            aria-label="Close Menu"
          >
            <X size={32} color="#67142D" />
          </button>

          <ul className="flex flex-col gap-8 text-2xl text-[#67142D] font-semibold text-center">
            {navItems.map((item) => (
              <li
                key={item}
                className="cursor-pointer hover:text-[#B51F3B] transition-colors duration-200"
                onClick={() => {
                  handleNavigation(item);
                  toggleMenu();
                }}
              >
                {item}
              </li>
            ))}
          </ul>
          
          {/* Mobile Donate Button */}
          <div className="mt-8">
            <button
              onClick={() => {
                handleDonateClick();
                toggleMenu();
              }}
              className="bg-[#67142D] text-white px-8 py-4 rounded-lg font-semibold text-xl hover:bg-[#B51F3B] transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:scale-105"
            >
              Donate Now
            </button>
          </div>
        </div>
      )}
      
      {/* Donation Popup */}
      <DonationPopup 
        isOpen={isDonationPopupOpen} 
        onClose={handleCloseDonationPopup}
      />
    </div>
  );
};

export default Navbar;
